module.exports = __webpack_public_path__ + "img/icon-shoucang.e88d1ee1.svg";